import { CheckboxFill, StatusEmpty } from '@lyearn/icons';
import { IconType } from '@/components/IconSettings';
import { StatusCategoryEnum } from '@/types/schema';

import StatusProgressIcon from '../../components/StatusProgressIcon';

const STATUS_ICON_MAP: Record<StatusCategoryEnum, IconType> = {
  [StatusCategoryEnum.NotStarted]: StatusEmpty,
  [StatusCategoryEnum.InProgress]: StatusProgressIcon,
  [StatusCategoryEnum.Completed]: CheckboxFill,
};

export default STATUS_ICON_MAP;
